import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyBanner() {
  const [visible, setVisible] = useState(() => {
    return localStorage.getItem('privacy-consent') !== 'accepted';
  });

  const accept = () => {
    localStorage.setItem('privacy-consent', 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: '#0B1628',
      borderTop: '1px solid rgba(212,160,23,0.25)',
      padding: '14px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      flexWrap: 'wrap',
      boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
    }}>
      <div style={{ flex: 1, minWidth: 260 }}>
        <span style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.75)', lineHeight: 1.5 }}>
          OptiKa uses local storage to keep you logged in and sync offline sales. No tracking cookies.{' '}
          <Link
            to="/privacy"
            style={{ color: '#D4A017', textDecoration: 'none', fontWeight: 600 }}
          >
            Privacy Policy
          </Link>
        </span>
      </div>
      <div style={{ display: 'flex', gap: 10, flexShrink: 0 }}>
        <button
          onClick={accept}
          style={{
            background: 'linear-gradient(135deg, #D4A017, #F0C040)',
            color: '#0B1628',
            border: 'none',
            borderRadius: 7,
            padding: '8px 20px',
            fontSize: '0.82rem',
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
            transition: 'opacity 150ms',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
          onMouseLeave={e => e.currentTarget.style.opacity = '1'}
        >
          Accept
        </button>
        <button
          onClick={() => setVisible(false)}
          style={{
            background: 'rgba(255,255,255,0.08)',
            color: 'rgba(255,255,255,0.6)',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 7,
            padding: '8px 14px',
            fontSize: '0.82rem',
            cursor: 'pointer',
            fontFamily: 'inherit',
            transition: 'opacity 150ms',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
          onMouseLeave={e => e.currentTarget.style.opacity = '1'}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
